import React from "react";
import ss from "./Button.module.css";
// import classNames from "classnames";

export default function Button(props) {
  const { title, onClick } = props;

  return (
    <div className={ss.btn} onClick={onClick}>
      {title}
    </div>
  );
}
